import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import { Subject, filter, take, takeUntil } from 'rxjs';
import { HcSort, HcTableDataSource, ModalService, PaginationComponent, SimpleModalOptions } from '@healthcatalyst/cashmere';
import { KeyElement, KeyService } from '../../shared/services/key.service';

/** Admin list of API keys */
@Component({
    selector: 'pd-admin-keys',
    templateUrl: './admin-keys.component.html',
    styleUrls: ['./admin-keys.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AdminKeysComponent implements OnInit, AfterViewInit, OnDestroy {
    private unsubscribe = new Subject<void>();
    dataSource: HcTableDataSource<KeyElement> = new HcTableDataSource();
    loading = true;
    loadError = false;
    adminKeysDisplayedColumns: string[] = ['name', 'value', 'username', 'date', 'actions'];
    adminKeysPageSize: number = 10;

    @ViewChild(HcSort)
    sort: HcSort;
    
    @ViewChild(PaginationComponent)
    paginator: PaginationComponent;

    get adminKeysListLength(): number {
        return this.dataSource.filteredData ? this.dataSource.filteredData.length : 0;
    }

    constructor( private keyService: KeyService, private modalService: ModalService ) {}

    ngOnInit(): void {
        this.keyService.keyListUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(list => {
            if (list) {
                this.loading = false;
                this.loadError = false;
                this.dataSource = new HcTableDataSource(list);
                if ( this.sort && this.paginator ) {
                    this.dataSource.sort = this.sort;
                    this.dataSource.paginator = this.paginator;
                }
            } else {
                this.loadError = this.keyService.loadFailed;
                if (!this.loadError) {
                    this.loadKeys();
                } else {
                    this.loading = false;
                }
            }
        });
    }

    ngAfterViewInit(): void {
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
    }

    loadKeys(): void {
        this.keyService.refresh(true);
    }

    removeKey( element: KeyElement ): void {
        const options: SimpleModalOptions = {
            messageHTML: '<p>Are you sure you want to delete the API Key: <strong>' + element.name + '</strong>? This action can not be undone.<p>',
            headerText: 'Delete Key',
            confirmButtonText: 'Delete Key',
            icon: ''
        };
        this.modalService
            .confirmDestructive(options)
            .pipe( take(1), filter(confirmed => confirmed))
            .subscribe(() => {
                this.keyService.remove( element, false );
            });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}